module.exports = __webpack_public_path__ + "static/media/title.9c77a8e8.svg";